import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  isSoundOffMessage,
  isSoundOnMessage,
  type SoundOffMessage,
  type SoundOnMessage,
} from '@module/types/centrifuge/public-message/soundMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class SoundOnHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<SoundOnMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isSoundOnMessage(payload);
  }

  handle(payload: SoundOnMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setVolume?.(0.5);
    context.setMuted?.(false);
  }
}

export class SoundOffHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<SoundOffMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isSoundOffMessage(payload);
  }

  handle(payload: SoundOffMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setVolume?.(0);
    context.setMuted?.(true);
  }
}
